import PropTypes from "prop-types";
import { useEffect, useMemo, useState } from "react";
import { startCase, toLower } from "lodash";

import Dropdown from "@shared/v2/Dropdown";
import { LEAD_STAGE_MAPPING, CANDIDATE_STAGE_MAPPING } from "../../shared/StagesDropDown/StagesDropDown";

const StageFilter = ({ stages }) => {
  const options = useMemo(
    () => [
      {
        ...LEAD_STAGE_MAPPING[0],
        label: startCase(toLower(LEAD_STAGE_MAPPING[0].label)),
        options: LEAD_STAGE_MAPPING.slice(1).map((option) => ({
          ...option,
          label: startCase(toLower(option.label)),
          value: `(${option.type}) ${option.value}`,
        })),
      },
      {
        ...CANDIDATE_STAGE_MAPPING[0],
        label: startCase(toLower(CANDIDATE_STAGE_MAPPING[0].label)),
        options: CANDIDATE_STAGE_MAPPING.slice(1).map((option) => ({
          ...option,
          label: startCase(toLower(option.label)),
          value: `(${option.type}) ${option.value}`,
        })),
      },
    ],
    [],
  );

  const [selectedOptions, setSelectedOptions] = useState(
    stages?.map((stage) => {
      const group = /\(lead\)/.test(stage) ? options[0] : options[1];
      // Fall back to a synthetic option when the stored stage isn't in the
      // hardcoded mapping (custom/renamed stages, or legacy unprefixed values).
      // Without this, `find` returns undefined and the hidden-input `.map` below
      // throws on `option.value`, crashing the whole control so the filter
      // silently disappears on reload.
      return group.options.find((option) => option.value === stage) || { label: stage, value: stage };
    }) || [],
  );

  useEffect(() => {
    const clearAllButton = document.querySelector("#clear-all-modal-filters");
    if (!clearAllButton) return () => {};
    const clearFilters = () => {
      setSelectedOptions([]);
    };
    clearAllButton.addEventListener("click", clearFilters);
    return () => clearAllButton.removeEventListener("click", clearFilters);
  }, []);

  return (
    <>
      <Dropdown
        options={options}
        components={{ MultiValueLabel: ({ data }) => `Stage: ${data.value}` }}
        label="Stage"
        value={selectedOptions}
        onChange={setSelectedOptions}
        menuShouldComeToFront
        isMulti
        multiShouldRenderBelowSelect
      />
      {selectedOptions.map((option) => (
        <input
          key={option.value}
          type="hidden"
          name="leads_filter[selected_stage_filters][]"
          id={`leads_filter_selected_stage_filters_${option.value}`}
          value={option.value}
          checked="checked"
        />
      ))}
    </>
  );
};

StageFilter.propTypes = {
  stages: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default StageFilter;
